// extracted by mini-css-extract-plugin
export default {"node-transition":"DesignOrchestrationDiagram_node-transition__Elo5e"};